import { injectGlobal } from '@emotion/css'
import {
  fontFamily,
  fontSize,
  fontWeight,
  colors,
  navbarHeight,
  breakpoint,
  mediaQueryHelper,
  lineHeight,
} from '@offerzen/pinata-shame'

injectGlobal({
  '*, *::after, *::before': {
    boxSizing: 'inherit',
  },
  html: {
    boxSizing: 'border-box',
  },
  body: {
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    lineHeight: lineHeight.default,
    margin: 0,
    color: colors.jumbo,
    backgroundColor: colors.catskillWhite,
  },

  strong: {
    fontWeight: fontWeight.semiBold,
  },
  '#root': {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',

    main: {
      [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
        paddingTop: navbarHeight,
      },
    },
  },
})
